// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form[data-v-2364c40e] {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 400px;\n}\n.form-edit-actions[data-v-2364c40e] {\n  display: flex;\n  gap: 10px;\n}\n.form-edit-actions > *[data-v-2364c40e] {\n  flex: 1;\n}", ""]);
// Exports
module.exports = exports;
